export const FEE_REIMBURSEMENTS = 'Fee Reimbursements';
export const MANAGE_PAYMENTS = 'FR Claims Pending Payment';

export const ATTORNEY = 'attorney';
